import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload.js'

const resourceName = 'ged'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=nivel,menu,asc&size=500`, data, config)
const GetAllByMenu = (menuId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}&menuId=${menuId}&sort=nome,asc`, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClientUpload.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Search = (nome = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?name=${nome}&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Download = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/download/${id}`, config)

const GedRepository = {
  GetAll,
  GetAllPaging,
  GetAllByMenu,
  GetById,
  Create,
  Update,
  Search,
  ChangeStatus,
  Delete,
  Download
}

export default GedRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/ged/ged.js